import { AxiosError } from 'axios';
import { POST_ADD_RESOURCE } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';

// =============================================================================
// Request & Response Model
// =============================================================================

export interface AddResourceRequest {
  fileKey: string;
  examLevel: string;
  description: string;
  title: string;
  fileName: string;
  resourceType: string;
}

export interface AddResourceResponse {}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: AddResourceResponse) => void;
  onError?: (err: AxiosError) => void;
}

export const usePostAddResource = ({ onSuccess, onError }: Input) => {
  const postAddResource = async (payload: AddResourceRequest) => {
    const res = await axiosClient.post<AddResourceResponse>(POST_ADD_RESOURCE, payload);
    return res.data;
  };

  return useCustomMutation(postAddResource, {
    onSuccess,
    onError,
  });
};
